import React, { useEffect, useState } from 'react';
import { HistoryIcon, Stack, Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator, Typography } from '../../styles/MaterialUI';
import { ThreeDots } from 'react-loader-spinner';
import axios from 'axios';
import apiConstants from '../../constants/apiConstants';
import { useDispatch, useSelector } from 'react-redux';
import { showAlertPopup } from '../Redux/Features/showAlertSlice';

const ScreenCastingHistory = () => {
    const { screen_uiid } = useSelector((state) => state.editScreenData);
    const { userToken } = useSelector((state) => state.userToken);
    const headers = { Authorization: `Bearer ${userToken}` };
    const [castingHistoryList, setCastingHistoryList] = useState([]);
    const [showLoader, setShowLoader] = useState(true);
    const mapContentType = { "image": "Image", "video": "Video", "dashboard": "IntelliDash Dashboard", "content_playlist": "Content Playlist", "open_url": "Open URL" };
    const [integrationData, setIntegrationData] = useState([]);
    const dispatch = useDispatch();

    const formatDate = (input) => {
        if (input) {
            const newDate = new Date(input);
            return newDate.toLocaleString();
        }
        return input;
    }

    const fetchIntegrationData = async () => {
        const apiResponse = await axios.post(`${apiConstants.GET_API_URL}getIntegrations`, {}, { headers });
        const { data } = apiResponse.data;
        setIntegrationData(data);
    }

    const fetchCastingHistory = async () => {
        try {
            const response = await axios.post(`${apiConstants.GET_API_URL}getCastingHistory`, { screen_uiid: screen_uiid }, { headers });
            const { data } = response.data;

            setCastingHistoryList(data);
            setShowLoader(false);
        } catch (error) {
            setShowLoader(false);
            const { statusCode, message, redirect_url } = error.response.data;
            dispatch(showAlertPopup({ isOpen: true, severity: "error", message: message }));
            if (statusCode === 403) {
                window.open(redirect_url, "_self");
            }
        }
    }

    useEffect(() => {
        fetchIntegrationData();
        fetchCastingHistory();
    }, []);

    return (
        <>
            {castingHistoryList.length > 0 ?
                <Timeline position="right" sx={{ marginTop: "-30px", padding: 0 }}>
                    {
                        castingHistoryList.map((castingHistory, index, array) => {
                            return (
                                <TimelineItem key={index}>
                                    <TimelineOppositeContent
                                        sx={{ mt: "8px", whiteSpace: "normal", wordWrap: "break-word", padding: 0, textAlign: "center", flex: 0.5, fontSize: "0.75rem" }}
                                    >
                                        <>
                                            {formatDate(castingHistory.ic_createdon)}
                                            <br />
                                            Mapped by {castingHistory.created_by}
                                        </>
                                    </TimelineOppositeContent>
                                    <TimelineSeparator>
                                        <TimelineDot color="primary">
                                            <HistoryIcon />
                                        </TimelineDot>
                                        {index !== array.length - 1 && <TimelineConnector />}
                                    </TimelineSeparator>
                                    <TimelineContent sx={{ py: "10px", px: 1, mt: "-4px" }}>
                                        <Typography sx={{ fontSize: "0.75rem" }}>
                                            Content Type: {castingHistory.content_org_integration_id
                                                ? integrationData?.find(data => data.ic_org_integration_id === castingHistory.content_org_integration_id)?.integration_name ?? ""
                                                : mapContentType[castingHistory.content_type]}
                                        </Typography>
                                        <Typography sx={{ fontSize: "0.75rem" }}>
                                            Content Name: {castingHistory.content_name}
                                        </Typography>
                                        {castingHistory.ic_mapping_notes &&
                                            <Typography sx={{ fontSize: "0.75rem" }}>
                                                Notes: {castingHistory.ic_mapping_notes}
                                            </Typography>
                                        }
                                    </TimelineContent>
                                </TimelineItem>
                            )
                        })
                    }
                </Timeline> :
                showLoader ?
                    <Stack direction="row" display="flex" justifyContent="center" style={{ marginTop: "5px" }}>
                        <ThreeDots visible={showLoader} height="50" width="50" color="#003366" radius="9" ariaLabel="three-dots-loading" />
                    </Stack>
                    : <div style={{ textAlign: "center" }}><em>No Records Found...</em></div>
            }
        </>
    )
}

export default ScreenCastingHistory;
